import type { FC, MouseEventHandler } from 'react';
import type { EventConfig } from 'utils/amplitude/amplitude.types';

export interface IconButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement>;
  icon: FC<{ className?: string }>;
  buttonType?:
    | 'default'
    | 'taxes'
    | 'expenses'
    | 'revenues'
    | 'bank'
    | 'primary';
  style?: React.CSSProperties;
  className?: string;
  heightClass?: string;
  disabled?: boolean;
  tracingEvent?: EventConfig;
}

type CustomButtonBgColorTypeMap = Record<
  Exclude<IconButtonProps['buttonType'], undefined>,
  { backgroundColor: string; iconClassName?: string }
>;

export const customButtonBgColorTypeMap: CustomButtonBgColorTypeMap = {
  default: {
    backgroundColor: 'bg-primary-50',
    iconClassName: 'text-primary-800',
  },
  taxes: {
    backgroundColor: 'bg-taxes',
    iconClassName: 'text-white',
  },
  expenses: {
    backgroundColor: 'bg-expenses',
    iconClassName: 'text-white',
  },
  revenues: {
    backgroundColor: 'bg-revenues',
    iconClassName: 'text-white',
  },
  bank: {
    backgroundColor: 'bg-bank',
    iconClassName: 'text-white',
  },
  primary: {
    backgroundColor: 'bg-primary',
    iconClassName: 'text-white',
  },
};
